import { render } from "./course-media.vue?vue&type=template&id=debaaec8"
import script from "./course-media.vue?vue&type=script&lang=js"
export * from "./course-media.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__